import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { Observable, Subscription } from 'rxjs';
// import { CasesService } from 'src/app/modules/cases/services/cases.service';
@Component({
  selector: 'determinar-procedencia-del-caso',
  templateUrl: './determinar-procedencia-del-caso.component.html',
  styleUrls: ['./determinar-procedencia-del-caso.component.scss'],
})
export class DeterminarProcedenciaDelCaso implements OnInit {
  form: FormGroup;
  @Input() data: { task: any };
  @Input() saveEvent$: Observable<void>;
  @Input() saveEventObservable: Subscription;
  task: any;
  analista: string;

  constructor(
    private fb: FormBuilder // public _users: UserService, // private casesServices: CasesService
  ) {}

  ngOnInit(): void {
    const { task } = this.data;
    this.task = task;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      observacion: [values ? values.observacion : '', [Validators.required]],
      existeProcedencia: [
        values ? values.existeProcedencia : '',
        [Validators.required],
      ],
      // analista: [values ? values.analista : this.analista],
      // tipoReclamo: [values ? values.tipoReclamo : ''],
      reclamosMagneticos: [
        values ? values.reclamosMagneticos : '',
        [Validators.required],
      ],
    });
    // this.getAnalista(task.case);
    // this.saveEventObservable = this.saveEvent$.subscribe(() => this.onSave());
  }

  // async getAnalista(idCaso: string) {
  //   this.casesServices.getCase(idCaso).subscribe((res) => {
  //     console.log(res);
  //     // this.analista = `${analista.nombre} ${analista.apellido}`;
  //   });
  // }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }

  // onSave() {
  //   console.log(this.task);
  //   console.log('Onsave activated', this.form.value.reclamosMagneticos);
  //   let tarea =
  //     this.form.value.reclamosMagneticos == true
  //       ? 'Reclamos de Medios Magnéticos'
  //       : 'Reclamos de Medios NO Magnéticos';
  //   this._tareacaso.crearTarea(this.task.idCaso, tarea).toPromise();
  // }

  ngOnDestroy() {
    if (this.saveEventObservable) {
      this.saveEventObservable.unsubscribe();
    }
  }
}
